"use client";

import { Box, CircularProgress } from "@mui/material";
import { useRouter, usePathname } from "next/navigation";
import { useTranslations } from 'next-intl';
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authUser as fetchAuthUser, checkSiteMaintenanceCall } from "../services/AuthService"; // Renamed to avoid conflict
import { logout } from "../services/AuthService";
import { setAuthUser, resetAuth } from "../store/slices/authUser";
import { reset } from "../store/slices/product";
import { resetsignup } from "../store/slices/signupUser";
import FreeSetupCallModal from "./Modals/FreeSetupCallModal";
const Wrapper = ({
  children,
  skipAuth
}) => {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const authUser = useSelector(state => state.auth.authUser);
  const [loading, setLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(true);
  const router = useRouter();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const g = useTranslations('general');
  const recentSignupEmail = useSelector(state => state?.signupUserSlice?.email);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetchAuthUser();
        if (response.data?.user) {
          if (response.data?.user.redirection_url && pathname != "/aws-authorization" && !response.data?.user.store.skip_now) {
            router.push("/amazon-market-place");
            return;
          }

          // if (!response.data?.user.productExit && pathname != "/on-boarding" && pathname != "/packages" && pathname != "/payment-status" && pathname != "/market-place") {
          //   await router.push("/on-boarding");
          //   return;
          // }
          setLoading(false);
          dispatch(setAuthUser(response.data.user));
        } else {
          dispatch(resetAuth());
          router.push("/");
        }
      } catch (error) {
        dispatch(resetAuth());
        // Note: Deactivated account message is shown by axios interceptor
        router.push("/");
      }
    };
    // if (!authUser || Object.keys(authUser).length === 0) {
    if (!skipAuth) {
      checkAuth();
    } else {
      setLoading(false);
    }
  }, [skipAuth]);
  useEffect(() => {
    const checkSiteMaintenance = async () => {
      try {
        const response = await checkSiteMaintenanceCall(); // Call the API
        setMaintenance(false);
      } catch (e) {
        const isMaintenanceMessage = e?.response?.data?.message?.includes("Front site is under maintenance.");
        const isMaintenanceStatus = e?.response?.status === 503;
        if (isMaintenanceMessage || isMaintenanceStatus) {
          router.push("/maintenance");
        } else {
          setMaintenance(false);
        }
      }
    };
    checkSiteMaintenance();
  }, [skipAuth]);
  useEffect(() => {
    if (!pathname.startsWith('/content-enrichment')) {
      dispatch(reset());
    }
    if (!pathname.startsWith('/email-varification') && recentSignupEmail) {
      dispatch(resetsignup());
    }
  }, [pathname]);
  useEffect(() => {
    const userLogout = async () => {
      await logout().then(response => {
        localStorage.removeItem("token");
        dispatch(setAuthUser({}));
        enqueueSnackbar(g('logoutSuccess'), {
          variant: "success",
          autoHideDuration: 2000
        });
      }).catch(e => {});
    };
    if (skipAuth) {
      if (pathname == "/" && localStorage.getItem("token")) {
        userLogout();
      }
      setLoading(false);
      return;
    }
  }, [skipAuth]);

  // Timer for Free Setup Call Modal
  const [showSetupCallModal, setShowSetupCallModal] = useState(false);
  useEffect(() => {
    let timer;
    // Check if user is logged in, is first visit, and we haven't shown it this session (managed by parent state effectively, but persistent check via localStorage is safer if required across refreshes)
    // Here we use a simple timer that starts when authUser is loaded.
    if (authUser?.is_first_visit) {
      // Check if we already showed it (optional: persistent storage)
      const hasSeen = localStorage.getItem('hasSeenFreeSetupModal');
      if (!hasSeen) {
        timer = setTimeout(() => {
          setShowSetupCallModal(true);
          localStorage.setItem('hasSeenFreeSetupModal', 'true');
        }, 300000); // 5 minutes = 300000ms
      }
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [authUser]); // Re-run if authUser changes (e.g. login)

  if (loading || maintenance) {
    return <div>
        <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh"
      }}>
          <CircularProgress size={70} thickness={5} color="inherit" />
        </Box>
      </div>;
  }
  return <>
      <FreeSetupCallModal open={showSetupCallModal} handleClose={() => setShowSetupCallModal(false)} data-sentry-element="FreeSetupCallModal" data-sentry-source-file="Wrapper.jsx" />
      {children}
    </>;
};
export default Wrapper;